"use client";

import dynamic from "next/dynamic";

export const MagazineReaderClient = dynamic(
  () => import("@/components/MagazineReader").then((mod) => ({ default: mod.MagazineReader })),
  {
    ssr: false,
    loading: () => (
      <div className="flex items-center justify-center py-20 text-sm text-muted-foreground">
        Loading magazine reader...
      </div>
    )
  }
);
